import type { Dispatch, KeyboardEvent, SetStateAction } from "react";

type DropdownNavigationOptions = {
  isOpen: boolean;
  isDisabled?: boolean;
  itemCount: number;
  open: () => void;
  setFocusedIndex: Dispatch<SetStateAction<number>>;
  onEscape: () => void;
  onTab: () => void;
};

// Keyboard navigation shared by every DS dropdown field: arrow movement,
// Escape and Tab, plus the disabled guard. Returns true when the key was
// consumed so callers can skip their component-specific keys (Enter / Space /
// typeahead / freeSolo commit), which differ between the components.
const handleDropdownNavigationKey = (
  e: KeyboardEvent,
  {
    isDisabled,
    isOpen,
    itemCount,
    onEscape,
    onTab,
    open,
    setFocusedIndex,
  }: DropdownNavigationOptions,
): boolean => {
  if (isDisabled) return true;

  switch (e.key) {
    case "ArrowDown": {
      e.preventDefault();
      if (!isOpen) {
        open();
      } else if (itemCount > 0) {
        setFocusedIndex((prev) => (prev + 1) % itemCount);
      }
      return true;
    }
    case "ArrowUp": {
      e.preventDefault();
      if (!isOpen) {
        open();
      } else if (itemCount > 0) {
        setFocusedIndex((prev) => (prev - 1 + itemCount) % itemCount);
      }
      return true;
    }
    case "Escape": {
      if (isOpen) {
        e.preventDefault();
        onEscape();
      }
      return true;
    }
    case "Tab": {
      if (isOpen) onTab();
      return true;
    }
    default:
      return false;
  }
};

export { handleDropdownNavigationKey };
